/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eg_Skyfall_ProductionsInputs */

const en_eg_skyfall_productions = /** @type {(inputs: Eg_Skyfall_ProductionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. SKYFALL PRODUCTIONS`)
};

const es_eg_skyfall_productions = /** @type {(inputs: Eg_Skyfall_ProductionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ej. SKYFALL PRODUCTIONS`)
};

const fr_eg_skyfall_productions = /** @type {(inputs: Eg_Skyfall_ProductionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. SKYFALL PRODUCTIONS`)
};

const de_eg_skyfall_productions = /** @type {(inputs: Eg_Skyfall_ProductionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. SKYFALL PRODUCTIONS`)
};

const ja_eg_skyfall_productions = /** @type {(inputs: Eg_Skyfall_ProductionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例: SKYFALL PRODUCTIONS`)
};

const zh_eg_skyfall_productions = /** @type {(inputs: Eg_Skyfall_ProductionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例如：SKYFALL PRODUCTIONS`)
};

const ar_eg_skyfall_productions = /** @type {(inputs: Eg_Skyfall_ProductionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مثال: SKYFALL PRODUCTIONS`)
};

const id_eg_skyfall_productions = /** @type {(inputs: Eg_Skyfall_ProductionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mis. SKYFALL PRODUCTIONS`)
};

const it_eg_skyfall_productions = /** @type {(inputs: Eg_Skyfall_ProductionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`es. SKYFALL PRODUCTIONS`)
};

const ru_eg_skyfall_productions = /** @type {(inputs: Eg_Skyfall_ProductionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`например, SKYFALL PRODUCTIONS`)
};

const pt_eg_skyfall_productions = /** @type {(inputs: Eg_Skyfall_ProductionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. PRODUÇÕES SKYFALL`)
};

const ko_eg_skyfall_productions = /** @type {(inputs: Eg_Skyfall_ProductionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`예: 스카이폴 프로덕션`)
};

/**
* | output |
* | --- |
* | "e.g. SKYFALL PRODUCTIONS" |
*
* @param {Eg_Skyfall_ProductionsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const eg_skyfall_productions = /** @type {((inputs?: Eg_Skyfall_ProductionsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eg_Skyfall_ProductionsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eg_skyfall_productions(inputs)
	if (locale === "es") return es_eg_skyfall_productions(inputs)
	if (locale === "fr") return fr_eg_skyfall_productions(inputs)
	if (locale === "de") return de_eg_skyfall_productions(inputs)
	if (locale === "ja") return ja_eg_skyfall_productions(inputs)
	if (locale === "zh") return zh_eg_skyfall_productions(inputs)
	if (locale === "ar") return ar_eg_skyfall_productions(inputs)
	if (locale === "id") return id_eg_skyfall_productions(inputs)
	if (locale === "it") return it_eg_skyfall_productions(inputs)
	if (locale === "ru") return ru_eg_skyfall_productions(inputs)
	if (locale === "pt") return pt_eg_skyfall_productions(inputs)
	return ko_eg_skyfall_productions(inputs)
});